import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './styles.m.scss';

import Body from './Body';
import Action from './Action';
import Header from './Header';

const propTypes = {
  announcement: PropTypes.bool,
  certification: PropTypes.bool,
  children: PropTypes.any,
  className: PropTypes.string,
  error: PropTypes.bool,
  registration: PropTypes.bool,
  membership: PropTypes.bool,
  symposium: PropTypes.bool,
  training: PropTypes.bool,
};

const Card = ({
  announcement,
  certification,
  children,
  className,
  error,
  registration,
  membership,
  symposium,
  training,
}) => {
  const cardClasses = cn('card', className, {
    [styles.announcement]: announcement,
    [styles.certification]: certification,
    [styles.error]: error,
    [styles.registration]: registration,
    [styles.membership]: membership,
    [styles.symposium]: symposium,
    [styles.training]: training,
  });

  return <div className={cardClasses}>{children}</div>;
};

Card.propTypes = propTypes;
Card.Body = Body;
Card.Action = Action;
Card.Header = Header;

export default Card;
